import React from "react";
const Toggle = ({ type, disabled, maxWidth, fontSizeText, name, checked, redUnchecked, onClick, extentedClick }) => {

    const isChecked = !!checked;

    return <div
        style={{ display: "flex", alignContent: "center", alignItems: "center", flexDirection: "row", gap: "10px",
            maxWidth: maxWidth ? maxWidth + "px" : null
        }}
        onClick={extentedClick ? (e) => {
            onClick && onClick(!isChecked);
        } : null}>
        <label className={type === "check" || type === "checkCircle" ? "SquareRadioButton" : "SwitchButton"}>
            <input name={name} type="checkbox" disabled={disabled} checked={isChecked}
                onChange={(e) => { // Rules React with input
                    if (!extentedClick) {
                        onClick && onClick(e.target.checked);
                    }
                }}
                onClick={(e) => {
                    if (extentedClick) {
                        e.preventDefault(); // Prevents default comportment
                        e.stopPropagation(); // Prevents propagation to parent Div
                    }
                }}
                readOnly={!!extentedClick} // Indicate to React don't use onChange but continue to use onClick
            />
            <span className={type === "check" ? "checkmark" : type === "checkCircle" ? "checkmark-circle" : "slider"} style={{ backgroundColor: !checked && redUnchecked ? "var(--red-base)" : null }}></span>
        </label>
        { name ?
            <div className="TextContent16" style={{ color: checked ? "var(--primary-base)" : !checked && redUnchecked ? "var(--red-base)" : !disabled ? "var(--carbone)" : "var(--grey-light)", fontSize: fontSizeText ? fontSizeText : null }}>
                {name}
            </div> : null
        }
    </div>;
};
export default Toggle;
